let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bgiDE")).then(() => parcelRequire('hKJ7s'));